import { nzStrings, auStrings } from "../components/Footer/footerInfo";

export function getRegional(stringId) {
  return window.location.href.includes(process.env.REACT_APP_NZ_ROOT_DOMAIN)
    ? nzStrings[stringId]
    : auStrings[stringId]; // default to AU
}
